import React, { useState } from 'react';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import Label from 'components/form/Label/Label';
import { ReactComponent as TooltipFilledBlue } from 'style/icons/tooltip-filled-blue.svg';
import { ReactComponent as TooltipOutline } from 'style/icons/tooltip-outline.svg';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';
import classNames from '../../../../../node_modules/classnames/index';
import { Image } from 'components/Image/Image';

const PrePopulatedTooltip = ({ prePopulatedTooltipText, tooltipWhite }) => {
  const [isVisible, setIsVisible] = useState(false);

  const onPrefillTooltipChangeHandler = e => {
    setIsVisible(e);
  };

  const colorTooltip = classNames({
    fontWhite: tooltipWhite,
    fontGray300: !tooltipWhite,
  });

  return (
    <>
      {prePopulatedTooltipText && (
        <CSTooltip
          title={prePopulatedTooltipText}
          isInline={true}
          onVisibleChangeHandler={onPrefillTooltipChangeHandler}
          tooltipName={'Pre-Populated Tooltip'}
          vertical={CREDIT_CARD_VERTICAL}
        >
          <Label type="text-12" className="padtpbt10" color={colorTooltip}>
            <FlexContainer className="align-items-center">
              {`Your application may be pre-populated.`}
              {!tooltipWhite &&
                (isVisible ? <TooltipFilledBlue /> : <TooltipOutline />)}
              {tooltipWhite && <Image imgClass={'questionMarkTooltip'} />}
            </FlexContainer>
          </Label>
        </CSTooltip>
      )}
    </>
  );
};

export { PrePopulatedTooltip };
